import React, {
	useEffect, useState
}from "react"
import {
	Table,
	Pagination,
	Popconfirm,
	Tag,
	Tooltip
}from "antd"
import {
	useDebounce
}from "use-lodash-debounce"
import {
	reReportActions
}from "./store/actions"
import {
	useDispatch, useSelector
}from "react-redux"
import "antd/lib/popconfirm/style/css.js"
import "antd/lib/tag/style/index.css"
import 'antd/lib/tooltip/style/index.css'
import i18n from "../localization"
import i18nGlobal from "../../../localization"
import ReportCreateUpdateForm from "./modify"
import CustomButton from "../../../components/ButtonCustom"
import {
	CustomInput
}from "../../../components/CustomInput"
import LocalLoading from "../../../components/Loading/Local"
import Notifications from "../../../helpers/Notifications"
import CRUDIcons from "../../../components/CRUDIcons/index"

const ReReports = (props) => { //'Справочник отчётов' 
	const { isModify = false } = props
	const [table, setTable] = useState([])
	const [page, setPage] = useState(1)
	const pageSize = 10
	const [searchValue, setSearchValue] = useState("")
	const [visible, setVisible] = useState(false)
	const [record, setRecord] = useState(null)
	const searchWithPause = useDebounce(searchValue, 500)
	const dispatch = useDispatch()
	const isRu = useSelector((state) => state.globalReducer.isRu)

	const columns = [
		{
			dataIndex : 'reportKind',
			editable  : false,
			inputType : 'text',
			key       : 'reportKind',
			render    : ((value) => {
				return isRu ? value.name : value.nameBel
			}),
			title : i18n.tableHeaderView[isRu],
			width : 250
		},
		{
			dataIndex : 'name',
			editable  : false,
			inputType : 'text',
			key       : 'name',
			render    : ((value, record) => {
				return isRu ? record.name : record.nameBel
			}),
			title : i18n.tableHeaderCode[isRu],
			width : 500
		},
		{
			dataIndex : 'code',
			editable  : false,
			inputType : 'text',
			key       : 'code',
			title     : i18n.tableHeaderCode[isRu],
			width     : 50
		},
		{
			dataIndex : 'reportHierarchies',
			editable  : false,
			inputType : 'text',
			key       : 'reportHierarchies',
			render    : ((value) => {
				return (
					<>
						{ value.map((item) => {
							return (
								<Tooltip
									key={ `Tooltip${ item.code }` }
									title={ isRu ? item.name : item.nameBel }
								>
									<Tag key={ `Tag${ item.code }` }>
										{ item.code }
									</Tag>
								</Tooltip>
							)
						}) }
					</>)
			}),
			title : i18n.tableHeaderCharacteristic[isRu],
			width : 150
		},
		{
			dataIndex : 'startDate',
			editable  : false,
			inputType : 'text',
			key       : 'startDate',
			title     : i18n.tableHeaderDateStart[isRu],
			width     : 90
		},
		{
			dataIndex : 'endDate',
			editable  : false,
			inputType : 'text',
			key       : 'endDate',
			title     : i18n.tableHeaderDateEnd[isRu],
			width     : 90
		}
	]

	const { isSending, reportChanged, reports } = useSelector((state) => state.reReportReducer)

	const getAllPaged = (params) => {
		dispatch(reReportActions.getAllPaged(params))
	}
	const updateReport = (params) => {
		dispatch(reReportActions.updateReport(params))
	}
	const restoreReport = (params) => {
		dispatch(reReportActions.restoreReport(params))
	}
	const createReport = (params) => {
		dispatch(reReportActions.createReport(params))
	}
	const deleteReport = (params) => {
		dispatch(reReportActions.deleteReport(params))
	}

	useEffect(() => {
		return () => {
			dispatch(reReportActions.clear())
		}
	}, [])

	useEffect(() => {
		setTable(reports?.items?.map((value, index) => {
			return {
				change            : isModify && value.id,
				code              : value.code,
				delete            : isModify && value.id,
				endDate           : value.endDate ? new Date(value.endDate).toLocaleDateString('ru-RU') : "",
				id                : value.id,
				isDeleted         : value.isDeleted,
				name              : value.name,
				nameBel           : value.nameBel,
				reportHierarchies : value.reReportHierarchies,
				reportKind        : value.reReportKind,
				rowKey            : index,
				startDate         : new Date(value.startDate).toLocaleDateString('ru-RU')
			}
		}) ?? [])
	}, [reports])

	useEffect(() => {
		onPaginationChange(1)
	}, [searchWithPause])

	useEffect(() => {
		if (reportChanged){
			Notifications.successNotice(reportChanged, "", 15)
			onPaginationChange(page)
		}
	}, [reportChanged])

	function onPaginationChange(value){
		setPage(value)
		getAllPaged({
			name     : searchWithPause?.trim(),
			page     : value,
			pageSize : pageSize
		})
	}

	function showModal(id){
		const item = reports?.items?.find((value) => {
			return value.id === id
		})
		setRecord(item)
		setVisible(true)
	}

	isModify
		? columns.push({
			dataIndex : "change",
			key       : "update",
			render    : (id, record) => {
				return (
					<>
						<span title={ i18n.buttonEdit[isRu] }>
							{
								!record.isDeleted && CRUDIcons.update(() => {
									showModal(id)
								})
							}
						</span>
						<span title={ record.isDeleted ? i18n.buttonRestore[isRu] : i18n.buttonDelete[isRu] }>
							<Popconfirm
								cancelText={ i18nGlobal.no[isRu] }
								okText={ i18nGlobal.yes[isRu] }
								title={ record.isDeleted ? i18n.messageChooiseUpdateItem[isRu] : i18n.messageChooiseDeleteItem[isRu] }
								onCancel={ () => {
									return null
								} }
								onConfirm={ () => {
									record.isDeleted ? restoreReport({ id: record.id }) : deleteReport({ id: record.id })
								} }
							>
								{!record.isDeleted 
									? CRUDIcons.delete() 
									: CRUDIcons.restore()}

							</Popconfirm>
						</span>
					</>
				)
			},
			width: 150
		})
		: null

	return (
		<>
			{ window.scrollTo(0, 0) }
			{ isModify && (
				<ReportCreateUpdateForm
					create={ createReport }
					record={ record }
					setRecord={ setRecord }
					setVisible={ setVisible }
					update={ updateReport }
					visible={ visible }
				/>
			) }
			<div className="header-admin-nsi">
				<CustomInput
					maxLength={ 50 }
					placeholder={ i18n.placeholderSearchInput[isRu] }
					onChange={ (e) => setSearchValue(e.target.value) }
				/>
				{ isModify && (
					<CustomButton
						className="add-nsi"
						loading={ isSending }
						type="orange"
						onClick={ () => showModal(null) }
					>
						<div>
							{CRUDIcons.create()}
							<span>
								{ i18n.buttonAdd[isRu] }
							</span>
						</div>
					</CustomButton>
				) }
			</div>
			<Table
				columns={ columns }
				dataSource={ table }
				loading={ { indicator : <LocalLoading />,
					spinning  : isSending } }
				pagination={ false }
				scroll={ { x: 1000 } }
			/>
			{
				((reports?.count ?? 0) > pageSize) && (
					<Pagination
						current={ page }
						pageSize={ pageSize }
						showSizeChanger={ false }
						total={ reports.count }
						onChange={ onPaginationChange }
					/>
				)
			}
		</>
	)
}

export default ReReports
